import React, { useState } from 'react';
import ChatWindow from '../components/ChatWindow';
import ModelSelector from '../components/ModelSelector';
import Sidebar from '../components/Sidebar';

const Chat = () => {
  const [selectedModel, setSelectedModel] = useState('chatgpt');
  const [selectedChatId, setSelectedChatId] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleNewChat = () => {
    setSelectedChatId(null);
    setIsSidebarOpen(false);
  };

  const handleChatSelect = (chatId) => {
    setSelectedChatId(chatId);
    setIsSidebarOpen(false);
  };

  const handleChatCreated = (chatId) => {
    setSelectedChatId(chatId);
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="flex h-screen bg-gray-50">
      {/* Sidebar */}
      <Sidebar
        isOpen={isSidebarOpen}
        onClose={() => setIsSidebarOpen(false)}
        onNewChat={handleNewChat}
        selectedChatId={selectedChatId}
        onChatSelect={handleChatSelect}
      />

      {/* Main Content */}
      <div className="flex-1 flex flex-col min-w-0">
        {/* Header */}
        <div className="bg-white shadow-sm border-b border-gray-200 px-3 sm:px-4 py-3 sm:py-4 lg:px-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              {/* Mobile sidebar toggle */}
              <button
                onClick={toggleSidebar}
                className="lg:hidden p-2 hover:bg-gray-100 rounded-md transition-colors"
              >
                <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              </button>
              
              <div className="min-w-0">
                <h1 className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-900 truncate">
                  AI Chat
                </h1>
                <p className="text-xs sm:text-sm text-gray-600 hidden sm:block">
                  Chat with multiple AI models
                </p>
              </div>
            </div>

            {/* Model Selector */}
            <div className="flex items-center">
              <div className="hidden sm:flex items-center space-x-3">
                <span className="text-sm font-medium text-gray-700 hidden md:block">Model:</span>
                <ModelSelector 
                  selectedModel={selectedModel}
                  onModelChange={setSelectedModel}
                />
              </div>
              
              {/* Mobile model selector */}
              <div className="sm:hidden">
                <ModelSelector 
                  selectedModel={selectedModel}
                  onModelChange={setSelectedModel}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Chat Area */}
        <div className="flex-1 min-h-0">
          <ChatWindow 
            selectedModel={selectedModel}
            chatId={selectedChatId}
            onChatCreated={handleChatCreated}
          />
        </div>
      </div>
    </div>
  );
};

export default Chat;
